import { useSetting } from "@faire/marketplace-lib/settings/__internal__/useSetting";
import { FE_ENABLE_PRODUCT_QUICK_VIEW_250924 } from "@faire/retailer-settings/FE_ENABLE_PRODUCT_QUICK_VIEW_250924";

export const useSettingEnableProductQuickView = () => {
  const settingValue = useSetting(FE_ENABLE_PRODUCT_QUICK_VIEW_250924);
  const isLinkVersion = settingValue === "link";
  const isButtonVersion = settingValue === "button";
  const isEnabled = isLinkVersion || isButtonVersion;
  return { isLinkVersion, isButtonVersion, isEnabled };
};
